import React from 'react'

const RightBlackIcon = () => {
    return (
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.82213 0.176601C9.58496 -0.0588671 9.2004 -0.0588671 8.96327 0.176601L3.55677 5.5444L1.03673 3.04243C0.79956 2.80696 0.415005 2.80696 0.177875 3.04243C-0.0592916 3.27789 -0.0592916 3.65966 0.177875 3.89513L3.12731 6.82345C3.36444 7.05888 3.7491 7.05881 3.98616 6.82345L9.82213 1.02927C10.0593 0.7938 10.0593 0.41207 9.82213 0.176601Z" fill="black" />
        </svg>
    )
}

export default RightBlackIcon